@if (newsCount() && (hasUnreadNews$ | async)) {
    <div class="news-bar">
        <a
            class="news-header-message"
            [routerLink]="[[PROJECTS_ROUTE] | translateRoute, { outlets: NEWS_OUTLET | translateOutlet }]"
            [relativeTo]="activatedRoute"
            queryParamsHandling="preserve"
            (click)="hideNews()"
            >{{ 'global.news_available' | translate }}</a
        >
        <sfx-icon
            size="s"
            (click)="hideNews()"
            [icon]="xMarkIcon"
        ></sfx-icon>
    </div>
}
